export default class MediaUtils {
    static isMobileBrowser(){
        var os = (function() {
            var ua = navigator.userAgent,
              isWindowsPhone = /(?:Windows Phone)/.test(ua),
              isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
              isAndroid = /(?:Android)/.test(ua),
              isFireFox = /(?:Firefox)/.test(ua),
              isChrome = /(?:Chrome|CriOS)/.test(ua),
              isTablet =
                /(?:iPad|PlayBook)/.test(ua) ||
                (isAndroid && !/(?:Mobile)/.test(ua)) ||
                (isFireFox && /(?:Tablet)/.test(ua)),
              isPhone = /(?:iPhone)/.test(ua) && !isTablet,
              isPc = !isPhone && !isAndroid && !isSymbian;
            return {
              isTablet: isTablet,
              isPhone: isPhone,
              isAndroid: isAndroid,
              isPc: isPc
            };
        })();
        if (os.isAndroid || os.isPhone || os.isTablet) {
            return true;
        }
        return false;
  }
  
  static getCookieDomain(){
    return process.env.COOKIE_DOMAIN;
  }

  static getStaticDomain(){
    return process.env.STATIC_DOMAIN;
  }

  static getDesignURL(val){
    if (val == 1) {
      return "static/html/design.html";
    }
    if (val == 2) {
      return "static/html/design_en.html";
    }
  }
  static getChrome(value){
    return "https://www.google.com/intl/zh-CN/chrome/";
  }
}


// WEBPACK FOOTER //
// ./src/utils/MediaUtils.js